import React from "react";

import { AudienceDto } from "@intelligems/ig-types";

interface TempTargetingTooltipProps {
  audienceState: AudienceDto | undefined | null;
}
export const TempTargetingTooltip = ({
  audienceState,
}: TempTargetingTooltipProps) => {
  return (
    <>
      <br />
      <br />
      {audienceState?.evaluationFrequency ? (
        <>
          Temporary: Visitors are re-evaluated every{" "}
          {audienceState?.evaluationFrequency} days once they match the audience
        </>
      ) : (
        <>
          Permanent: Visitors are included in the Personalization permanently
          once they match the criteria
        </>
      )}
    </>
  );
};
